module.exports = __webpack_public_path__ + "img/Goal_11.0abbe327.png";